import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {axiosInstance} from '../services/Api';

// Async thunk for login
export const loginUser = createAsyncThunk(
  'user/login',
  async ({ login, password }, { rejectWithValue }) => {
    try {
    
      const response = await axiosInstance.post('/users/login', { login, password }); // Replace with your login API endpoint
      // Assuming the API returns user data and a token
      const { user,permissions, token } = response.data;
      // Save token to localStorage or other secure storage
      sessionStorage.setItem('token', token); // This is fine since token is already a string
      sessionStorage.setItem('user', JSON.stringify(user)); // Convert the user object to JSON
      sessionStorage.setItem('permissions', JSON.stringify(permissions)); // Convert the permissions object to JSON

      return response.data;
    } catch (error) {
      // Handle API errors
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const registerUser = createAsyncThunk(
  'user/register',
  async ({ login, password, email, ownerName }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/users/register', { login, password, email,ownerName });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);
export const updateUser = createAsyncThunk(
  'user/update',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/users/update', userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const fetchUsers = createAsyncThunk(
  'user/fetchUsers',
  async (_,{ rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/users');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null, // Stores logged-in user data
    users:[],
    loading: false,
    selectedUser:null,
    error: null,
    message:null,
  },
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
    clearSelectedUser: (state) => {
      state.selectedUser = null;
    },

    logoutUser: (state) => {
      state.user = null;
      state.loading = false;
      state.error = null;
      // Clear token from localStorage
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('permissions');
      sessionStorage.removeItem('user');
    },
    clearMessage:(state) => {
      state.message=null;
  }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload; // Store user data
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message; // Store error message
      })
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.message='Utilisateur crée un mail de validation à été envoyer'
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
        
      })
      builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true; // Set loading state to true when the action is pending
        state.error = null;   // Clear previous errors
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false; // Set loading state to false when the action is fulfilled
        state.users = action.payload; // Populate users with the fetched data

      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false; // Set loading state to false when the action is rejected
        state.error = action.payload || 'Failed to fetch users'; // Set the error message
      })
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        state.message='Utilisateur modifier avec succes'
        setSelectedUser(action.payload)
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
        
      });
  },
});

export const { logoutUser ,clearMessage,setSelectedUser,clearSelectedUser } = userSlice.actions;
export default userSlice.reducer;
